var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaijie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 1.52466C16 1.52468 16 1.52469 16 1.52471C16 1.52469 16 1.52468 16 1.52466ZM16 1.52466C16 1.52396 16 1.52362 15.9999 1.52362L16 1.52466ZM4.36361 11.3528H4.86361V10.8528V8.10632H8.22722H8.72722V7.60632V4.86875H12.0729H12.5729V4.36875V1.64908H16V2.5711V3.09877V14.3506H1V11.3528H4.36361ZM8.72731 4.74317C8.72734 4.74316 8.72734 4.74357 8.72722 4.74438C8.72722 4.74358 8.72728 4.74318 8.72731 4.74317Z",
    fill: "#D9D9D9",
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaijie);
export default __webpack_public_path__ + "static/media/taijie.f4d9b63332b7da6e79cc8e9d35170719.svg";
export { ForwardRef as ReactComponent };